import React, { useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import CateringSetupTimeInput, { CateringSetupTimeHelp } from 'components/CateringSetupTimeInput';
import { cateringSetupTimeError } from 'utils/cateringSetupTime';
import { StyledWrapper } from './styles';

function CateringSetupTimeEditor({
  value,
  onSave,
}) {
  const [draft, setDraft] = useState(value);
  const [error, setError] = useState(() => cateringSetupTimeError(value));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setDraft(value);
    setError(cateringSetupTimeError(value));
  }, [value]);

  const handleSave = () => {
    const validationError = cateringSetupTimeError(draft);
    if (validationError) {
      setError(validationError);
      return;
    }
    setError(null);
    setSaving(true);
    Promise.resolve(onSave(Number(draft)))
      .catch((saveError) => {
        setError(saveError?.message || 'Could not save catering setup time.');
      })
      .finally(() => setSaving(false));
  };

  return (
    <StyledWrapper>
      <div className="box" data-testid="catering-setup-time">
        <div className="box-title">Fulfillment</div>
        <label className="catering-setup-label" htmlFor="catering-setup-time">
          Catering setup time (minutes)
        </label>
        <div className="catering-setup-row">
          <CateringSetupTimeInput
            id="catering-setup-time"
            className="catering-setup-input"
            value={draft}
            onChange={(next) => {
              setDraft(next);
              setError(cateringSetupTimeError(next));
            }}
          />
          <Button
            type="primary"
            onClick={handleSave}
            loading={saving}
            disabled={Boolean(error) || saving}
          >
            Save
          </Button>
        </div>
        {error && (
          <Typography.Text className="catering-setup-error" type="danger" role="alert">
            {error}
          </Typography.Text>
        )}
        <CateringSetupTimeHelp />
      </div>
    </StyledWrapper>
  );
}

export default CateringSetupTimeEditor;
